import {
  Avatar,
  Box,
  IconButton,
  Tooltip,
  Typography,
  Modal,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TableContainer from "../../Components/TableContainer";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../../Config/AxiosInstance";
import { ApiList } from "../../Config/ApiList";
import DummyUser from "../../Assets/User.webp";
import CloseIcon from "@mui/icons-material/Close";

const Feedbacks = () => {
  const pageSize = 15;
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const [totalData, setTotalData] = useState(0);

  const [openModal, setOpenModal] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState("");

  const getUserList = async (params) => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post(ApiList.USER_GET, params);
      if (response?.data?.s === 1) {
        const formattedUsers = response?.data?.r?.map((user, index) => ({
          rowid: index + 1 + page * pageSize,
          ...user,
        }));
        setUserData(formattedUsers);
        if (params.skip === 0) {
          const totalCount = response?.data?.total || 0;
          localStorage.setItem("totalCount", totalCount);
          setTotalData(totalCount);
        } else {
          const totalCountFromStorage = localStorage.getItem("totalCount");
          setTotalData(
            totalCountFromStorage ? Number(totalCountFromStorage) : 0
          );
        }
        setLoading(false);
      } else {
        setUserData([]);
        setTotalData(0);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setLoading(false);
    }
  };

  const fetchUserList = () => {
    const skip = page * pageSize;
    const params = {
      select:
        "fr.*, u.image AS user_image, u.username, u.fname, u.lname,u.email",
      from: "feedbacks_review AS fr JOIN users AS u ON u.id = fr.user_id",
      arg: "fr.status = ? ORDER BY fr.id DESC",
      prms: 1,

      skip,
      limit: pageSize,
      total: 1,
    };
    getUserList(params);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    fetchUserList();
  }, [page]);

  const handleOpenModal = (mediaUrl) => {
    setSelectedMedia(mediaUrl);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedMedia("");
  };

  const columns = [
    {
      field: "rowid",
      headerName: "Sr.No",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "image",
      headerName: "Profile",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Avatar
          sx={{
            width: "40px",
            height: "40px",
            objectFit: "contain",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={
              params?.row?.user_image
                ? `${ApiList?.IMG_URL}${params?.row?.user_image}`
                : DummyUser
            }
            style={{ width: "100%", height: "100%" }}
          ></img>
        </Avatar>
      ),
    },
    {
      field: "media",
      headerName: "Media",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Avatar
          sx={{
            width: "40px",
            height: "40px",
            objectFit: "contain",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => handleOpenModal(`${ApiList.IMG_URL}${params?.row?.media}`)}
        >
          <img
            src={
              params?.row?.media ? `${ApiList.IMG_URL}${params?.row?.media}` : DummyUser
            }
            style={{ width: "100%", height: "100%" }}
          ></img>
        </Avatar>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const name = `${params?.row?.fname || ""} ${params?.row?.lname || ""}`;
        const truncatedCaption =
          name?.length > 20 ? `${name.substring(0, 20)}...` : name;
        return (
          <Tooltip title={`${params?.row?.fname} ${params?.row?.lname}`}>
            {truncatedCaption}
          </Tooltip>
        );
      },
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const userName = params?.row?.title;
        const truncatedCaption =
          userName?.length > 20 ? `${userName.substring(0, 20)}...` : userName;
        return <Tooltip title={params?.row?.title}>{truncatedCaption}</Tooltip>;
      },
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const userName = params?.row?.description;
        const truncatedCaption =
          userName?.length > 25 ? `${userName.substring(0, 25)}...` : userName;
        return (
          <Tooltip title={params?.row?.description}>{truncatedCaption}</Tooltip>
        );
      },
    },
  ];

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: "#B9CC0310",
          overflow: "hidden",
        }}
      >
        <Box sx={{ width: "100%", p: 2, background: "#B9CC0310" }}>
          <Typography
            sx={{
              fontSize: { xs: "18px", md: "28px" },
              fontWeight: "300",
              color: "#000",
            }}
          >
            Feedbacks/Suggestions
          </Typography>
        </Box>
        <Box sx={{ width: "100%", height: "calc(100vh - 74px)" }}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              p: 1,
              overflow: "scroll",
            }}
          >
            <TableContainer
              columns={columns}
              rows={userData}
              handlePageChange={handlePageChange}
              page={page}
              loading={loading}
              totalData={totalData}
              pageSize={pageSize}
            />
          </Box>
        </Box>
      </Box>

      {/* Modal for Media */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        BackdropProps={{
          sx: {
            backdropFilter: "blur(5px)", // Apply blur effect
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: Semi-transparent overlay
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "80%",
            width: "400px",
            height: "400px",
            bgcolor: "none",
            // boxShadow: 24,
            p: 2,
            borderRadius: 2,
            outline: "none",
          }}
        >
          <IconButton
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
          <img
            src={selectedMedia}
            alt="Media Preview"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "8px",
              objectFit: "contain",
            }}
          />
        </Box>
      </Modal>
    </>
  );
};

export default Feedbacks;
